import { render, staticRenderFns } from "./companyRealName.vue?vue&type=template&id=6000b90b&"
import script from "./companyRealName.vue?vue&type=script&lang=js&"
export * from "./companyRealName.vue?vue&type=script&lang=js&"
import style0 from "./companyRealName.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports